import "babel-polyfill" //解决IE空白问题，必须放第一位，不要动它
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router/index.js'
import store from './store/store'
import API from './api/API'
import common from './assets/js/HzCommon.js'
import util from './assets/js/util.js'
import * as filters from './filter/commonFilter.js'
import config from './api/config'
import  VueQuillEditor from 'vue-quill-editor'
import { VueJsonp } from 'vue-jsonp'
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
});

require('./assets/css/style.css');
require('.././static/iconfont/iconfont.css');

//定义全局变量
Vue.prototype.api = API;
Vue.prototype.util = util;
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(common);
Vue.use(VueQuillEditor);
Vue.use(VueJsonp);

/* eslint-disable no-new */
router.beforeEach((to, from, next) => {
    if (to.path === '/login') {
        next();
    } else {
        //如果当前路由需要登录 并且 未登录，则跳转路由到login
        if (!localStorage.getItem('isLogin')) {
            next('/login');
        } else {
            next();
        }
    }
});

new Vue({
    el: '#app',
    router,
    store, //全局使用store
    template: '<App/>',
    components: { App }
});


// WEBPACK FOOTER //
// ./src/main.js